import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../../shared";
import { DataService_MealType } from "../../shared/data.service";

@Component({
	selector: "caass-subsidy-pricing-table",
	templateUrl: "./subsidy-pricing-table.component.html",
	styleUrls: ["./subsidy-pricing-table.component.css"],
})
export class SubsidyPricingTableComponent implements OnInit {
	constructor(private userService: UserService, private MealSubsidyTypeService: DataService_MealType, private dialogService: DialogService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadMealSubsidyType();
	}

	ngOnChanges() {
		this.loadMealSubsidyType();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() MealID: any;

	lstUsePct: any = [
		{
			ID: 1,
			Desc: "Yes",
		},
		{
			ID: 0,
			Desc: "No",
		},
	];

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedMealSubsidyType: any;
	lstMealSubsidyType: any = [];

	//Filter lists
	lstUsePctDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "MealSubsidyTypeCD", header: "Code" },
		{ field: "MealSubsidyTypeDesc", header: "Description" },
		// { field: 'MealCostDesc', header: 'Meal Cost' },
		// { field: 'UsePctDesc', header: 'Use Percentage' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadMealSubsidyType() {
		if (this.MealID == undefined) {
			return;
		}

		var result = this.MealSubsidyTypeService.MealCostSelectList(this.MealID);
		result.subscribe(
			(response) => {
				this.lstMealSubsidyType = response;

				//Load Data Filter Lists
				this.lstUsePctDesc = Array.from(new Set(this.lstMealSubsidyType.map((item: any) => item.UsePctDesc))).sort();
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadMealSubsidyType();
	}

	//Custom Button Methods

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onUsePctChange(MealSubsidyType, val) {
		MealSubsidyType.UsePct = val;

		if (val == 1) {
			MealSubsidyType.UsePctDesc = "Yes";
			MealSubsidyType.MealCostDesc = MealSubsidyType.MealCostSubsidyPct;
		} else {
			MealSubsidyType.UsePctDesc = "No";
			MealSubsidyType.MealCostDesc = MealSubsidyType.MealCostAmount;
		}

		this.lstUsePctDesc = Array.from(new Set(this.lstMealSubsidyType.map((item: any) => item.UsePctDesc))).sort();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedMealSubsidyType = val.data;
	}
	onRowUnselect(val) {
		this.SelectedMealSubsidyType = null;
	}
	onRowDblClick(MealSubsidyType) {
		this.SelectedMealSubsidyType = MealSubsidyType;
		// this.onEditMealSubsidyType();
	}
	////////////////////////////////////////////
}
